import $ from "jquery"
import I18n from "lib/i18n"

// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import BasePage from "pages/base_page"

class InstitutionPage extends BasePage {
  static initClass() {
    this.prototype.events = {
      "click #tabbed-navigation a": "_handleTabClick",
      "click .load-more-button": "_loadMoreArticles",
    }
  }

  _handleTabClick(event) {
    event.preventDefault()
    const section = $(event.currentTarget).attr("href")

    $("#tabbed-navigation a.active").removeClass("active")
    $(event.currentTarget).addClass("active")

    switch (section) {
      case "#articles":
        $(".institution-page").removeClass("sm-display-contributors sm-display-jobs-and-events")
        $(".institution-page").addClass("sm-display-articles")
        break
      case "#contributors":
        $(".institution-page").removeClass("sm-display-articles sm-display-jobs-and-events")
        $(".institution-page").addClass("sm-display-contributors")
        break
      case "#jobs-and-events":
        $(".institution-page").removeClass("sm-display-articles sm-display-contributors")
        $(".institution-page").addClass("sm-display-jobs-and-events")
        break
      default:
        break
    }
  }

  _loadMoreArticles(event) {
    event.preventDefault()

    const $button = $(event.currentTarget)
    const loadMoreUrl = $button.data("loadMoreUrl")

    if ($button.attr("data-loading") === "true") {
      return
    }

    if (!loadMoreUrl) {
      window.location.href = $button.attr("href")
      return
    }

    const originalLabel = $button.html()

    this._setLoadingState($button)

    fetch(loadMoreUrl, {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then((response) => {
        if (!response.ok) throw new Error(I18n.t("institution_page.error.load_more_failed"))
        return response.json()
      })
      .then((payload) => {
        this._appendArticles(payload)
        this._replaceLoadMoreButton($button, payload.load_more_html)
        this._updateLocation(payload.current_page_path)
      })
      .catch(() => {
        this._resetButtonState($button, originalLabel)
        // eslint-disable-next-line no-alert
        alert(I18n.t("institution_page.error.load_more_failed_retry"))
      })
  }

  _appendArticles(payload) {
    if (!payload.articles_html) return

    $("#articles-list").append(payload.articles_html)
  }

  _replaceLoadMoreButton($button, nextButtonHtml) {
    $button.closest(".load-more-container").remove()

    if (!nextButtonHtml || nextButtonHtml.trim().length === 0) return

    $("#articles").append(nextButtonHtml)
  }

  _setLoadingState($button) {
    $button.html(I18n.t("institution_page.label.loading"))
    $button.addClass("is-loading")
    $button.attr("aria-disabled", "true")
    $button.attr("data-loading", "true")
  }

  _resetButtonState($button, originalLabel) {
    $button.html(originalLabel)
    $button.removeClass("is-loading")
    $button.removeAttr("aria-disabled")
    $button.removeAttr("data-loading")
  }

  _updateLocation(path) {
    if (!path) return

    window.history.replaceState({}, "", path)
  }
}

InstitutionPage.initClass()

export default InstitutionPage
